import React from 'react';
import SbEditable from 'storyblok-react';

import DeferredYouTubeEmbed from './deferred-youtube-embed';
import './video.scss';

const Video = (props) => {
  const youtubeParse = props.blok.video_url.match(
    /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/
  );
  const brightcoveParse = props.blok.video_url.match(/https?:\/\/players.brightcove.net\//);
  const vimeoParse = props.blok.video_url.match(/https:\/\/player\.vimeo\.com\/video\/(\d+)\?h=(\d+)/);

  if (brightcoveParse) {
    if (!props.blok.width || !props.blok.height) {
      return <span>Width and Height required for Brightcove videos.</span>;
    }

    return (
      <iframe
        src={props.blok.video_url}
        allowfullscreen=""
        frameborder="0"
        width={props.blok.width}
        height={props.blok.height}
      ></iframe>
    );
  } else if (youtubeParse && youtubeParse.length >= 6) {
    const videoId = youtubeParse[5];

    return (
      <div className="video-embed">
        <SbEditable content={props.blok}>
          <DeferredYouTubeEmbed id={videoId} />
        </SbEditable>
      </div>
    );
  } else if (vimeoParse && vimeoParse.length >= 3) {
    return (
      <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
        <iframe
          src={`https://player.vimeo.com/video/${vimeoParse[1]}?h=${vimeoParse[2]}`}
          frameborder={0}
          allowFullScreen
          allow="autoplay; fullscreen; picture-in-picture"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} />
      </div>
    )
  }

  return <span>Unsupported or invalid video URL.</span>;
};

export default Video;
